module.exports = __webpack_public_path__ + "1ef7dd144f921cc220abc60a9a30630f.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudablackunicase-webfont.woff2
// module id = 1309
// module chunks = 28